import React, { useState, useEffect } from 'react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import { useToast } from '../hooks/use-toast';

const Contact = () => {
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Create mailto link with form data
    const subject = encodeURIComponent(`Contact Form: Message from ${formData.name}`);
    const body = encodeURIComponent(
      `Name: ${formData.name}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`
    );
    const mailtoLink = `mailto:contact@dreamsportsfoundation.org?subject=${subject}&body=${body}`;
    
    // Open email client
    window.location.href = mailtoLink;
    
    toast({
      title: "Opening Email Client",
      description: "Your default email application will open to send the message.",
    });
  };

  return (
    <div className="contact-page">
      <section className="page-banner-section grunge-texture">
        <div className="page-banner-image">
          <img 
            src="/contact-banner.png" 
            alt="Dream Sports Foundation Contact"
            className="page-banner-img"
          />
        </div>
      </section>

      <section className="contact-content-section grunge-texture">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2 className="heading-2">Let's Connect</h2>
              <p className="body-medium">
                Whether you're an athlete looking to compete, a coach keen to upskill, or a partner interested in collaborating, we'd love to hear from you.
              </p>
              <div className="contact-details">
                <div className="contact-detail-item">
                  <h4 className="heading-5">Email</h4>
                  <p className="body-medium">contact@dreamsportsfoundation.org</p>
                </div>
                <div className="contact-detail-item">
                  <h4 className="heading-5">Address</h4>
                  <p className="body-medium">7th Floor, Ascent, Sudam Kalu Ahire Marg, opposite GSK, Worli, Mumbai - 400030.</p>
                </div>
              </div>
            </div>

            <div className="contact-form-wrapper">
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <Label htmlFor="name">Name</Label>
                  <Input
                    id="name"
                    name="name"
                    type="text"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Your full name"
                  />
                </div>
                <div className="form-group">
                  <Label htmlFor="email">Email</Label>
                  <Input
                    id="email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="your.email@example.com"
                  />
                </div>
                <div className="form-group">
                  <Label htmlFor="message">Message</Label>
                  <Textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    placeholder="Tell us about your interest or inquiry..."
                    rows={6}
                  />
                </div>
                <Button type="submit" className="btn-primary">Send Message</Button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;